export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/tile_housewarming-e5221a3d4d531a067a0e028cc655fe13.jpg";